module.exports = __webpack_public_path__ + "img/createBookshelf.d92c8455.svg";